/* app/js/src/components/content-control/studio/content-control-studio/shared-objects/mark-in-icon/mark-in-icon.component.scss */
:host {
  display: flex;
}
/*# sourceMappingURL=mark-in-icon.component.css.map */
